import {all, fork} from "redux-saga/effects";
import postshopLocatorSaga from "./postshop-locator/postshopLocatorSaga";

/**
 * All application sagas
 */
export default function* rootSaga() {
  yield all([
    fork(postshopLocatorSaga),
  ])
}


// WEBPACK FOOTER //
// ./src/redux/sagas/rootSaga.tsx